import OtpModel from '@/model/OtpModel.js';
import Moment from 'moment';
import BzbsOtp from "@/service/BzbsOtp.js";

export default {
    /**
     * @param {object} AuthRequestOTPParam
     */
    requestOTP: function(otpModel,authRequestOTPParam, recapchaKey) {
        return new Promise((resolve, reject) => {
            BzbsOtp.apiRequestOTP(authRequestOTPParam,recapchaKey)
                .then(objResult => {
                    otpModel.refcode = objResult.data.refcode
                    otpModel.expireTime = objResult.data.expireinseconds;
                    resolve(otpModel);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    SetRunOTPTimer : function (numExpireIn) {
        var OTPTimer = new OtpModel.OTPTimerModelBuilder().create();

        var numCurrentTime = Math.floor(Moment().utc().unix() / 1000);
        OTPTimer.numExpireIn = numExpireIn;
        OTPTimer.numExpireDate = numCurrentTime + numExpireIn;
        OTPTimer.numCurrentDate = numCurrentTime;
        OTPTimer.numOriginalStartDate = numCurrentTime;
        OTPTimer.isTimeRunning = true;

        return OTPTimer;
    },

}
